import image from '../../assets/img/megaschool/card-bg.png'

export const megaschoolList = [
    {
        tag: 'выпуск 1',
        title: 'Выбор премиксов для КРС',
        text: {
            quotes: '"',
            name: 'Елена Херувимских',
            text: 'Главный технический специалист департамента Свиноводство'
        },
        image_url: image
    },
    {
        tag: 'выпуск 2',
        title: 'Выбор премиксов для КРС',
        video_btn: true,
        image_url: image
    },
    {
        tag: 'выпуск 3',
        title: 'Выбор премиксов для КРС',
        text: {
            quotes: '"',
            name: 'Елена Херувимских',
            text: 'Главный технический специалист департамента Свиноводство'
        },
        image_url: image
    },
    {
        tag: 'выпуск 4',
        title: 'Выбор премиксов для КРС',
        video_btn: true,
        image_url: image
    }
]

export const megaschoolInfoItem = [
    {
        tag: 'для фермеров',
        title: 'Мегашкола',
        text: 'Новый образовательный проект от «Мегамикс» для фермеров в удобном и легком формате для восприятия. Мы собрали наиболее актуальные темы, которые нуждаются в пояснении и обсуждении, подготовили материал и записали все в формате видеолекций с наглядной инфографикой, чтобы вы всегда могли быть в курсе последних трендов. Подписывайтесь, выпусков будет все больше и больше.',
        btnText: 'Смотреть  на Youtube',
        btnTextOrange: 'На сайт Мегакорм'
    },
    {
        tag: 'для фермеров',
        title: 'Мегатревел',
        text: 'Серия роликов - "МегаТревел" открывает взгляд на опыт партнеров ГК «МЕГАМИКС» в использовании специальных решений в кормлении животных и птиц. Фермеры и руководители хозяйств делятся своими историями успеха, рассказывая о том, как использование передовых решений в области кормовых добавок, БВМК и премиксов помогло им достичь выдающихся результатов в своем бизнесе.',
        btnText: 'Принять участие',
        btnTextOrange: 'Смотреть на Youtube'
    }
]